export const DIRECTION = {
  PREV: "previous",
  NEXT: "next"
};
